import React from 'react'
import { useTranslation } from 'react-i18next'

export default function ContributorListHeader() {
  const { t } = useTranslation()
  return (
    <div className="columns" style={{ marginTop: 20 }}>
      <div className="column">
        <h1 className="title">{t('contributor.label')}</h1>
      </div>
      <div className="column is-pulled-right" />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/templates/contributor-list/ContributorListHeader.js